import styled from "styled-components"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"

const StyledLink = styled(TransitionFade)`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const StyledExternalLink = styled.a`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export { StyledLink, StyledExternalLink }
